import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BankAccounts from './Expand/BankAccounts';
import BusinessCardContent from './Expand/BussinessCard';
import UserCardContent from './Expand/UserCard';
import Card from './Expand/CardBlock';
import AmazonAccounts from './Expand/AmazonAccounts';
import { is8DataApp } from '../../utils';
import StoreConnections from './Expand/StoreConnections8Data';

const useStyles = makeStyles((theme: any) => ({
  container: {
    marginTop: theme.spacing(4),
  },
  bold: {
    fontWeight: 600,
  },
  businessButtonsWrap: {
    marginRight: theme.spacing(12),
  },
}));

export default function Layout({
  user,
  company,
  bankAccounts,
  setBankAccounts,
  amzAccounts,
  plaidLinkToken,
  setLoading,
  containerClass = '',
}) {
  const classes = useStyles();
  const expanedSection = window.location.hash?.slice(1);
  const is8Data = is8DataApp();

  return (
    <div className={`${classes.container} ${containerClass}`}>
      <Card key={1} title="Account Settings">
        <UserCardContent user={user}></UserCardContent>
      </Card>
      <Card key={2} title={is8Data ? 'Store Connections' : 'Business Details'}>
        {!is8Data && (
          <BusinessCardContent companyData={company}></BusinessCardContent>
        )}
        {is8Data && <StoreConnections companyData={company} />}
      </Card>
      {!is8Data && (
        <>
          <Card key={3} title="Bank Accounts">
            <BankAccounts
              bankAccounts={bankAccounts}
              setBankAccounts={setBankAccounts}
              plaidLinkToken={plaidLinkToken}
              setLoading={setLoading}
            />
          </Card>
          <Card
            key={4}
            title="Amazon Accounts"
            shouldExpand={expanedSection === 'amazon'}
          >
            <AmazonAccounts amzAccounts={amzAccounts} />
          </Card>
        </>
      )}
    </div>
  );
}
